// extracted by css-extract-rspack-plugin
export default {"row":"ChinaPaymentLogos-module__row","grid":"ChinaPaymentLogos-module__grid","logo":"ChinaPaymentLogos-module__logo"};